export class LogRecord {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "rowId",
            "baseName": "rowId",
            "type": "string",
            "format": ""
        },
        {
            "name": "raw",
            "baseName": "raw",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "string",
            "format": ""
        },
        {
            "name": "level",
            "baseName": "level",
            "type": "string",
            "format": ""
        },
        {
            "name": "fields",
            "baseName": "fields",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "partitionDate",
            "baseName": "partitionDate",
            "type": "string",
            "format": ""
        },
        {
            "name": "batchId",
            "baseName": "batchId",
            "type": "string",
            "format": ""
        },
        {
            "name": "matchPositions",
            "baseName": "matchPositions",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourcePath",
            "baseName": "sourcePath",
            "type": "string",
            "format": ""
        },
        {
            "name": "highlightedRaw",
            "baseName": "highlightedRaw",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LogRecord.attributeTypeMap;
    }
    constructor() {
    }
}
